// extracted by mini-css-extract-plugin
export var wrapper = "EventPreview-module--wrapper--wL81S";
export var thumbnail = "EventPreview-module--thumbnail--NF7GA";
export var title = "EventPreview-module--title--NvEB4";
export var copy = "EventPreview-module--copy--iZjpW";